import { CQLGeoserver } from "./CQLGeoserver.js";

/**
 * Represents a class for building SQL queries for Esri OGC services.
 * Extends the CQLGeoserver class.
 * @memberof vef.map.filters.builders
 */
export { SQLEsri }

class SQLEsri extends CQLGeoserver {

    /**
     * Retrieves the filter parameters for the SQL query.
     * Overrides the base class method.
     * @param {Object} harmonizedFilters - The harmonized filters object.
     * @returns {Object} - The filter parameters for the SQL query.
     */
    static getFilterParams(harmonizedFilters) {
        const filter = super.getFilterParams(harmonizedFilters);
        return (filter.cql_filter) ? { query: filter.cql_filter } : {};
    }

}